import React from 'react';
import { Route, BrowserRouter, Redirect } from 'react-router-dom';
import Login from './public/Login/Login';
import Settings from './private/Settings/Settings';
import Dashboard from './private/Dashboard/Dashboard';
import Orders from './private/Orders/Orders';
import OrderTemplates from './private/OrderTemplates/OrderTemplates';
import WithdrawTemplates from './private/WithdrawTemplates/WithdrawTemplates';
import WithdrawHistory from './private/WithdrawHistory/WithdrawHistory';
import Monitors from './private/Monitors/Monitors';
import Automations from './private/Automations/Automations';
import { getToken } from './services/TokenStorage';
import Reports from './private/Reports/Reports';
import Symbols from './private/Symbols/Symbols';
import Wallet from './private/Wallet/Wallet';
import WebHooks from './private/WebHooks/WebHooks';
import Strategies from './private/Strategies/Strategies';
import Performance from './private/Performance/Performance';
import TaxReport from './private/TaxReport/TaxReport';
import Futures from './private/Futures/Futures';
import Launchpad from './private/Launchpad/Launchpad';
import MarketSelection from './private/MarketSelection/MarketSelection';

function Routes() {

    function PrivateRoute({ children, ...rest }) {
        return (
            <Route {...rest} render={() => {
                return getToken()
                    ? children
                    : <Redirect to="/" /> 
            }} />
        )
    }

    return (
        <BrowserRouter>
            <Route path="/" exact>
                <Login />
            </Route>
            <PrivateRoute path="/settings">
                <Settings />
            </PrivateRoute>
            <PrivateRoute path="/dashboard">
                <Dashboard />
            </PrivateRoute>
            <PrivateRoute path="/monitors">
                <Monitors />
            </PrivateRoute>
            <PrivateRoute path="/automations">
                <Automations />
            </PrivateRoute>
            <PrivateRoute path="/orders/:symbol?">
                <Orders />
            </PrivateRoute>
            <PrivateRoute path="/futures">
                <Futures />
            </PrivateRoute>
            <PrivateRoute path="/markets">
                <MarketSelection />
            </PrivateRoute>
            <PrivateRoute path="/reports/:symbol?">
                <Reports />
            </PrivateRoute>
            <PrivateRoute path="/symbols">
                <Symbols />
            </PrivateRoute>
            <PrivateRoute path="/orderTemplates/:symbol?">
                <OrderTemplates />
            </PrivateRoute>
            <PrivateRoute path="/withdrawTemplates/:coin?">
                <WithdrawTemplates />
            </PrivateRoute>
            <PrivateRoute path="/withdrawHistory">
                <WithdrawHistory />
            </PrivateRoute>
            <PrivateRoute path="/wallet">
                <Wallet />
            </PrivateRoute>
            <PrivateRoute path="/webhooks">
                <WebHooks />
            </PrivateRoute>
            <PrivateRoute path="/strategies">
                <Strategies />
            </PrivateRoute>
            <PrivateRoute path="/launchpad">
                <Launchpad />
            </PrivateRoute>
            <PrivateRoute path="/performance">
                <Performance />
            </PrivateRoute>
            <PrivateRoute path="/tax">
                <TaxReport />
            </PrivateRoute>
        </BrowserRouter>
    )
}

export default Routes;